<script setup>
import {getTemplateContent} from "@/composables/email-templates/useEmailTemplates";
import PillButton from "@/components/email-templates/partials/PillButton.vue";
import {computed} from "vue";
import {successToast} from "@/composables/useToasts";
import _ from "lodash";

const {data} = getTemplateContent();

const excludedVariables = ['URL', 'SEO_AGENT_LINKS'];

const variables = computed(() => {
  const defaultVars = Object.keys(data.value?.default_variables ?? {})
    .filter(variable => !excludedVariables.includes(variable));

  const templateVars = (data.value?.email_content.email_template.variables ?? [])
    .filter(variable => !defaultVars.includes(variable));

  return _.sortBy([...defaultVars, ...templateVars]);
});

const components = computed(() => data.value?.email_content.email_template.components ?? []);

const toSentenceCase = (snakeCaseText) => {
  return snakeCaseText
    .toLowerCase()
    .split('_')
    .map(word => {
      if (['url', 'seo'].includes(word)) {
        return word.toUpperCase();
      }

      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
};

const copyVariableToClipboard = (variable) => {
  navigator.clipboard.writeText(`[[${variable}]]`);

  successToast('Copied to your clipboard!');
};

</script>

<template>
  <div class="tw-flex tw-flex-col tw-gap-y-6 tw-w-full">
    <div class="tw-flex tw-flex-col tw-gap-4">
      <div v-if="variables.length > 0">
        <h4 class="tw-text-sm tw-font-semibold tw-text-neutral-500 tw-uppercase tw-mb-3">
          Auto-fill tags
        </h4>
        <div class="tw-flex tw-flex-wrap tw-gap-2">
          <PillButton
            v-for="(variableName, index) in variables"
            :key="index"
            @click="copyVariableToClipboard(variableName)"
          >
            {{ toSentenceCase(variableName) }}
          </PillButton>
        </div>
      </div>

      <div v-if="components.length > 0">
        <h4 class="tw-text-sm tw-font-semibold tw-text-neutral-500 tw-uppercase tw-mb-3">
          Template Components
        </h4>
        <div class="tw-flex tw-flex-wrap tw-gap-2">
          <PillButton
            v-for="component in components"
            :key="component.id"
            @click="copyVariableToClipboard(component.variable_name)"
          >
            {{ toSentenceCase(component.variable_name) }}
          </PillButton>
        </div>
      </div>
    </div>
  </div>
</template>
